'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useId } from 'react';
import { cn } from '../../lib/cn.js';
import styles from './Field.module.css';
/** Shared label + error + hint + `aria-describedby` wiring (ux.md Forms;
 * CLAUDE_DESIGN.md §9). Every input in this package composes this instead
 * of re-deriving the a11y wiring three times. */
export function Field({ label, error, hint, required = false, className, children }) {
    const id = useId();
    const errorId = `${id}-error`;
    const hintId = `${id}-hint`;
    const describedBy = [error ? errorId : null, hint ? hintId : null].filter(Boolean).join(' ') || undefined;
    return (_jsxs("div", { className: cn(styles['field'], className), children: [_jsx("label", { htmlFor: id, className: cn(styles['label'], required && styles['required']), children: label }), children({
                id,
                ...(error ? { 'aria-invalid': true } : {}),
                ...(describedBy ? { 'aria-describedby': describedBy } : {}),
            }), hint && !error && (_jsx("p", { id: hintId, className: styles['hint'], children: hint })), error && (_jsx("p", { id: errorId, role: "alert", className: styles['error'], children: error }))] }));
}
